// extracted by mini-css-extract-plugin
export var bgImg = "cardFull-module--bgImg--81c07";
export var category = "cardFull-module--category--ca70e";
export var categoryLink = "cardFull-module--categoryLink--e854a";
export var categoryLinkWrapper = "cardFull-module--categoryLinkWrapper--9911b";
export var content = "cardFull-module--content--e154c";
export var heading = "cardFull-module--heading--3c9c1";
export var inner = "cardFull-module--inner--d11ae";
export var link = "cardFull-module--link--9cf67";
export var linkLabel = "cardFull-module--linkLabel--c9367";
export var linkWrapper = "cardFull-module--linkWrapper--f89ee";
export var text = "cardFull-module--text--0784e";
export var wrapper = "cardFull-module--wrapper--0b37d";